module.exports = __webpack_public_path__ + "media/honey-icons/icon-decreased-59c82f6a.svg";